/**
 * SaveFirstNotice — komunikat na zakładkach rekordu, które wymagają zapisanego nagłówka.
 *
 * Zakładki typu Kontakty / Adresy / Konta bankowe / Pola dodatkowe / Historia itd. są
 * pod-zasobami zapisywanymi osobno i mają sens dopiero, gdy rekord istnieje (ma `id`).
 * Przy tworzeniu nowego kontrahenta/pracownika renderowały wcześniej pustkę (`null`) —
 * użytkownik nie wiedział, że musi najpierw zapisać nagłówek. Ten komponent zastępuje tę
 * pustkę czytelną informacją.
 *
 * Dumb component — dostaje gotowy (przetłumaczony) `message`, żeby nie wiązać go z konkretną
 * przestrzenią i18n (kontrahent vs pracownik mają własne klucze).
 */

import type { ReactElement } from 'react';
import { Info } from 'lucide-react';

export function SaveFirstNotice({ message }: { message: string }): ReactElement {
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-dashed border-border-secondary bg-bg-tertiary px-3 py-3 text-sm text-text-tertiary"
      role="status"
      data-testid="save-first-notice"
    >
      <Info size={16} aria-hidden="true" className="mt-0.5 shrink-0 text-text-muted" />
      <span>{message}</span>
    </div>
  );
}
